<template>
  <div class="ref-list">
    <div class="box has-background-light">
      <div class="columns">
        <div class="column is-2">סה"כ: {{total}}</div>

        <div class="column s-2">
        <h3>סדר לפי</h3>
        <div class="select is-primary">
          <select v-model="sortby">
            <option value="leads">לידים</option>
            <option value="conversions">המרות</option>
            <option value="percentage">אחוז המרה</option>
            <option value="id">ID</option>
          </select>
        </div>
      </div>

        <div class="column">
        <h3>כיוון</h3>
        <div class="select is-primary">
          <select v-model="sortdir">
            <option value="up">סדר עולה</option>
            <option value="down">סדר יורד</option>
          </select>
        </div>
      </div>

      <div class="column">
        <h3>סינון לפי אימייל</h3>
        <div class="field">
          <div class="control">
            <input class="input is-success" type="text"
            v-model="filterTerm" placeholder="אימייל">
          </div>
        </div>
      </div>

        <div class="column has-text-left">
          <button class="button is-success new-ref-btn"
          @click="openNewRef">צור אפיליאייט חדש</button>
        </div>

      </div>
    </div>


    <div class="table-scroll">
      <table class="table is-striped is-hoverable is-fullwidth">
        <thead>
          <th>ID</th>
          <th>קישור</th>
          <th>שם משתמש</th>
          <th>נוצר בתאריך</th>
          <th>לידים</th>
          <th>המרות</th>
          <th>פעיל</th>
          <th>פירוט</th>
        </thead>
        <tbody>
          <ref-item v-for="item in show" :item="item" :key="item.id"></ref-item>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import RefItem from "./RefItem";

export default {
  data() {
    return {
      sortdir: "up",
      sortby: "leads",
      filterTerm: ""
    };
  },
  components: {
    RefItem
  },
  computed: {
    list() {
      let output = [];

      output = this.sortRefs();

      if (this.sortdir === "down") {
        return output.reverse();
      }
      return output;
    },
    show() {
      return this.list.filter(
        item => item.username.indexOf(this.filterTerm) > -1
      );
    },
    total() {
      return this.$store.state.total;
    }
  },

  methods: {
    openNewRef() {
      this.$store.commit("openNewRef");
    },

    sortRefs() {
      let refs = this.$store.state.refList;

      let output = [];

      if (this.sortby === "leads") {
        const byleads = refs.sort((a, b) => {
          return a.leads.length - b.leads.length;
        });
        output = byleads;
      }

      if (this.sortby === "id") {
        const byId = refs.sort((a, b) => {
          return a.id - b.id;
        });
        output = byId;
      }

      if (this.sortby === "conversions") {
        const byConversions = refs.sort((a, b) => {
          return (
            a.leads.filter(c => c.status > 0).length -
            b.leads.filter(c => c.status > 0).length
          );
        });
        output = byConversions;
      }

      if (this.sortby === "percentage") {
        const bypercentage = refs.sort((a, b) => {
          let pa, pb;
          if (
            a.leads.length === 0 ||
            a.leads.filter(c => c.status > 0).length === 0
          ) {
            pa = 0;
          } else {
            pa = a.leads.filter(c => c.status > 0).length / a.leads.length;
          }

          if (
            b.leads.length === 0 ||
            b.leads.filter(c => c.status > 0).length === 0
          ) {
            pb = 0;
          } else {
            pb = b.leads.filter(c => c.status > 0).length / b.leads.length;
          }
          return pa * 100 - pb * 100;
        });
        output = bypercentage;
      }

      return output;
    }
  }
};
</script>

<style lang="scss">
.new-ref-btn {
  margin-top: 25px;
}
</style>
